module.exports = __webpack_public_path__ + "img/11.002436b6.jpg";